import { requestForApi } from "../../utils/httpUtil";


/**
 *  保存古树巡查信息信息
 * @param params 古树巡查信息实体对象
 * 返回操作成功与否
 */
export async function saveAncientInspect(params: APIGarden.AncientInspectItem) {
    const res = await requestForApi('/api/v1/garden/ancients/inspects', {
        method: params?.id === undefined || params?.id === '' || params?.id === '0' ? 'POST' : 'PUT',
        data: params,
    });
    if (!res.result) {
        throw new Error(res.message);
    }
    return res.data;

}

/**
 *
 * @param id 根据ID拿到古树信息
 */
export async function queryAncientInfoById(id: string) {
    const res = await requestForApi(`/api/v1/garden/ancients/${id}`, {
        method: 'GET',
    });
    if (!res.result) {
        throw new Error(res.message);
    }
    return res.data;
}

export async function queryAncientInspect(params: APIGarden.AncientInspectParams) {
    const resp = await requestForApi('/api/v1/garden/ancients/inspects/search', {
        method: 'GET',
        data: params,
    });

    if (resp.result) {
        return Promise.resolve({
            data: resp.data?.list,
            success: true,
            total: resp.data?.pagination?.total,
            pageSize: resp.data?.pagination?.pageSize,
            current: resp.data?.pagination?.current,
        });
    }
    return Promise.resolve({
        data: [],
        success: false,
        total: 0,
        pageSize: 20,
        current: 1,
    });
}


/**
 *
 * @param id 根据ID拿到古树巡查对象
 */
export async function queryAncientInspectById(id: string) {
    const res = await requestForApi(`/api/v1/garden/ancients/inspects/${id}`, {
        method: 'GET',
    });
    if (!res.result) {
        throw new Error(res.message);
    }
    return res.data;
}